import { IWarehouse, IWarehouseResponse, IWarehouseFilter } from '../interfaces/IWarehouse';
import { RootState } from '../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';
import { WarehouseMapper } from '../mappers/warehouse.mapper';

export const warehousesApi = createApi({
  reducerPath: 'warehouseApi',
  tagTypes: ['Warehouse'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getWarehousesList: build.query<
      IWarehouseResponse,
      IWarehouseFilter
    >({
      transformResponse: (response: { data: IWarehouseResponse }) =>
        response.data,
      query: ({ page, query, order, orderDirection, filterId }) => ({
        url: '/warehouses/list',
        method: 'GET',
        params: {
          page,
          search: query,
          order,
          orderDirection,
          filterId,
        },
      }),
      providesTags: () => ['Warehouse'],
    }),
    getWarehouse: build.query<IWarehouse, number | string>({
      transformResponse: (response: { data: IWarehouse }) => 
        WarehouseMapper.toLocal(response.data),
      query: (id) => ({
        url: `/warehouses/${id}`,
        method: 'GET',
      }),
      providesTags: () => ['Warehouse'],
    }),
  }),
});

export default warehousesApi;

